module.exports = __webpack_public_path__ + "img/spoken_detail_0.ef48958c.svg";